import { render, staticRenderFns } from "./RodapeGrid.vue?vue&type=template&id=22497fd4&scoped=true"
import script from "./RodapeGrid.vue?vue&type=script&lang=js"
export * from "./RodapeGrid.vue?vue&type=script&lang=js"
import style0 from "./RodapeGrid.vue?vue&type=style&index=0&id=22497fd4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22497fd4",
  null
  
)

export default component.exports